export default __webpack_public_path__ + "static/media/icon_lock.d009ed91.png";